import { Navigate, useParams } from "react-router-dom";
import useCurrentSav from "./Hooks/useCurrentSav";
import { useEffect } from "react";

export default function CurrentSavContainer({
  children
}: {
  children: React.ReactNode;
}) {
  const { savId } = useParams();
  const {
    sav,
    setSav,
    loading,
    load,
    error,
  } = useCurrentSav();

  const currentSavId = sav?.id;

  useEffect(() => {
    if (!savId) {
      setSav(null);
      return;
    }
    if (parseInt(savId) === currentSavId) {
      return;
    }
    setSav(null);
    load(parseInt(savId));
  }, [savId, load, setSav, currentSavId]);

  if (!sav || loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Erreur: Le sav ne peut pas se charger</div>;
  }

  if (sav.uniqueId) {
    return <Navigate to={`/sav-v2/${sav.id}`} replace />;
  }

  return (
    children
  )
}